import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-confirmation',
  templateUrl: './generic-confirmation.component.html',
  styleUrls: ['./generic-confirmation.component.scss'],
  standalone: false
})
export class GenericConfirmationComponent implements OnInit {

  message: string = "";
  confirmLabel: string = "SI";
  cancelLabel: string = "NO";
  warning: boolean = false;
  warningAmber: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<GenericConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.message = this.data.message;
    this.warning = !!this.data.warning;
    this.warningAmber = !!this.data.warningAmber;
    if (this.data.english) {
      this.confirmLabel = "YES";
      this.cancelLabel = "NO";
    }
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close(true);
  }

}
